import {layout, ScrollableCard} from 'mc/lib';
import React, {Component} from 'react';
import {Card, CardBlock} from 'reactstrap';
import RegistraceForm from "../components/form/RegistraceForm";
import RegistraceApi from "../api/gen/pop/RegistraceApi";
import {modal} from 'mc/lib';
import {connect} from "react-redux";

class RegistracePage extends Component {

    state = {
        text: undefined,
        reCaptchaSiteKey: undefined,
    };

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        RegistraceApi.getRegistrationText().then(response => {
            this.setState({text: response});
        });
        RegistraceApi.getReCaptchaSiteKey().then(response => {
            this.setState({reCaptchaSiteKey: response});
        });
    }

    showResult(result) {
        if (result.vysledek) {
            this.props.history.push("/registrace/success")
        } else {
            const renderContent = () => {
                return <div>
                    <Card>
                        <CardBlock>{result.zprava}</CardBlock>
                    </Card>
                </div>
            };

            this.props.dispatch(modal.ModalActions.showInfo("Výsledek registrace", renderContent, true, null, { size: "lg" }));
        }
    }

    render() {
        const {text, reCaptchaSiteKey} = this.state;
        return (
            <div className="app-wrapper">
                <div className="app-wrapper-content">
                    <layout.PageWrapper className="registrace-wrapper">
                        <layout.PageContent fullWidth>
                            <ScrollableCard detail>
                                <RegistraceForm onSubmit={data => RegistraceApi.newRegistration(data)}
                                                text={text}
                                                reCaptchaSiteKey={reCaptchaSiteKey}
                                                onSubmitSuccess={result => this.showResult(result)}
                                />
                            </ScrollableCard>
                        </layout.PageContent>
                    </layout.PageWrapper>
                </div>
            </div>
        );
    }
}

export default connect()(RegistracePage);
